import React, { useContext } from 'react'
import "./RemovableVehicles.css"

const RemovableVehicles = ({ requestContext, vehicleContext, endorsementType }) => {
    const requestTypeContext = useContext(requestContext)
    const deleteVehicleContext = useContext(vehicleContext)
    var requestClass = (endorsementType == "RemoveVehicle") ? "removeVehicleClass" : (endorsementType == "ReplaceVehicle") ? "replaceVehicleClass" : "addVehicleClass"
    var vehicles = requestTypeContext[requestClass]?.vehicles?.vehiclesOnPolicy?.storedVehicles
    var vehicleSelected = requestTypeContext[requestClass]?.vehicles?.vehiclesOnPolicy?.removedVehicles

    return (
        <>
            <p className="vehicleText">Please select the vehicle you would like to remove.</p>
            {vehicles.map((vehicle, vehicleIndex) => {
                return (
                    <div key={vehicleIndex}>
                        <div className="radio ms-4">
                            <label className="form-check-label vehicleText d-flex align-items-start">
                                <input className="form-check-input" name={vehicleIndex} type="radio"
                                    value={vehicle}
                                    onChange={() => { deleteVehicleContext.removeSelectVehicle(vehicle, vehicleIndex) }}
                                    checked={vehicleSelected[0]?.VIN == vehicle?.VIN}
                                />
                                <span className="ms-2 flex-grow-1">{vehicle.Year} {vehicle.Make} {vehicle.Model} - {vehicle.VIN}</span>
                            </label>
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default RemovableVehicles